export default class BurgerMenu {
    constructor() {
        this.burgerMenu = '[data-burger-menu]';
        this.header = '[data-header]';

        this.classOpen = 'open';
        this.classLock = 'lock';

        $(document).on('click', this.burgerMenu, this.burgerMenuClickHandler.bind(this));

    }

    burgerMenuClickHandler(e) {
        $('body').toggleClass(this.classLock);
        $(this.header).toggleClass(this.classOpen);
        $(this.burgerMenu).toggleClass(this.classOpen);
    }
};
